import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
import { ILineInfoData, ITurn } from "@/domain/entities/lineInfo";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import BookChip from "../shared/chip/BookChip.vue";
import { useServiceStore } from "@/stores/serviceStore";
import LineSetTypeChip from "../shared/chip/LineSetTypeChip.vue";
import InlineSvg from "vue-inline-svg";
import { IBusStopData } from "@/domain/entities/busStop";


const __default__ = {
  name: "LineInfoDetailHeader",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineInfo: {
    type: Object as PropType<ILineInfoData>,
    required: true,
  },
  isLinePathExisted: {
    type: Boolean,
    default: false,
  },
  isFavoriteLine: {
    type: Boolean,
    default: false,
  },
  shouldShowTurnPathBtn: {
    type: Boolean,
    default: false,
  },
  shouldShowFavoriteBtn: {
    type: Boolean,
    default: false,
  },
  busStops: {
    type: Array as PropType<IBusStopData[]>,
    default: () => [],
  },
  selectedTurn: {
    type: Object as PropType<ITurn>,
  },
},
  emits: ["onClickLineTurnPathBtn", "onClickDetailBtn", "onClickFavoriteBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const serviceStore = useServiceStore();
const shouldShowTurnPath = serviceStore.serviceInfo?.shouldShowTurnPath;

/** 기점 정류장 */
const firstBusStop = computed(() => {
  if (!props.busStops.length) {
    return props.lineInfo.turns[0].firstStop;
  }

  return props.busStops[0];
});

/** 종점 정류장 */
const lastBusStop = computed(() => {
  if (!props.busStops.length) {
    return props.lineInfo.turns[0].lastStop;
  }

  return props.busStops[props.busStops.length - 1];
});

/** 노선에 예약 가능한 회차가 하나라도 있으면 예약 칩을 보여준다. */
const shouldShowBookChip = computed(() =>
  props.lineInfo.turns.some((turn) => turn.bookYn)
);

const turnPathBtnTitle = computed(() => {
  if (!shouldShowTurnPath) {
    return "지도보기";
  }
  return props.isLinePathExisted ? "경로보기" : "지도보기";
});

const emitOnClickLineTurnPathBtn = () => {
  emit("onClickLineTurnPathBtn");
};

const emitOnClickDetailBtn = () => {
  emit("onClickDetailBtn");
};

const emitOnClickFavoriteBtn = () => {
  emit("onClickFavoriteBtn", !props.isFavoriteLine);
};

const __returned__ = { props, emit, serviceStore, shouldShowTurnPath, firstBusStop, lastBusStop, shouldShowBookChip, turnPathBtnTitle, emitOnClickLineTurnPathBtn, emitOnClickDetailBtn, emitOnClickFavoriteBtn, get useGetLineRouteName() { return useGetLineRouteName }, BookChip, LineSetTypeChip, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})